/**
 * HomeStack
 * Navigatie voor het thuisscherm en alles wat daar bij hoort
 */

import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';
import {
  HomeScreen,
  ScannerScreen,
  ProductDetailScreen,
  AlternativesScreen,
  MinigameScreen,
} from '../screens';
import type {HomeStackParamList} from '../models/Navigation';

const Stack = createNativeStackNavigator<HomeStackParamList>();

export const HomeStackNavigator: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Stack.Navigator id={undefined}>
      <Stack.Screen
        name="Home"
        component={HomeScreen}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="Scanner"
        component={ScannerScreen}
        options={{
          title: t('scanner.title') || 'Scanner',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="ProductDetail"
        component={ProductDetailScreen}
        options={{
          title: t('product.title') || 'Product',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="Alternatives"
        component={AlternativesScreen}
        options={{
          title: t('alternatives.title') || 'Alternatieven',
          headerShown: true,
        }}
      />
      <Stack.Screen
        name="Minigame"
        component={MinigameScreen}
        options={{
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  );
};
